<template>
  <VRow no-gutters>
    <VCol v-if="sent" cols="12">
      <span>{{ $t('successMessage') }}</span>
    </VCol>
    <AppPreloader v-else-if="isLoading" />
    <VCol v-else cols="12">
      <VTextarea
        v-model="message"
        outlined
        :hide-details="!error.errors.message"
        :error-messages="error.errors.message"
        rows="3"
        background-color="#fff"
        @input="error.errors.message = null"
      >
        <template #label>
          <span class="body-2 grey--text">
            {{ $t('tip') }}
          </span>
        </template>
      </VTextarea>
      <div class="mt-6 text-center">
        <VBtn
          color="primary"
          class="white--text mr-4"
          :loading="isLoading"
          @click="submit"
        >
          {{ $t('refuse') }}
        </VBtn>
        <VBtn
          color="#ffffff"
          dark
          text
          class="blue--text"
          @click="$emit('cancel')"
        >
          {{ $t('cancel') }}
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>

<script>
import ApiMixin from '../mixins/ApiMixin';

export default {
  name: 'InterviewRefuseForm',
  mixins: [ApiMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
    predefinedMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      message: this.predefinedMessage,
      error: {
        errorMessage: null,
        errors: {},
      },
      sent: false,
      isLoading: false,
    };
  },
  computed: {
    hasErrorMessageOnly() {
      return !Object.keys(this.error.errors).length && this.error.errorMessage;
    },
  },
  created() {
    if (this.predefinedMessage) {
      this.submit();
    }
  },
  methods: {
    async submit() {
      this.$emit('refused');

      try {
        await this.withApiErrorHandling(async () => {
          await this.$store.dispatch('candidate/refuse', {
            candidateId: this.candidateId,
            message: this.message,
          });
          this.sent = true;
        }, 'error', 'isLoading');
      } catch (e) {
        if (this.hasErrorMessageOnly) {
          this.$toast.error(this.error.errorMessage);
        }
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  tip: It would be useful for the HR-manager
  refuse: Refuse
  cancel: Cancel
  successMessage: Thanks for your feedback. We will no longer communicate with you about this job.
</i18n>

<i18n locale="ru" lang="yaml">
  tip: В свободной форме, это будет очень полезно для специалиста по подбору персонала.
  refuse: Отказаться
  cancel: Отмена
  successMessage: Спасибо за обратную связь. Мы больше не будем беспокоить вас по этой вакансии.
</i18n>
